import { render, staticRenderFns } from "./basic-info.vue?vue&type=template&id=0b45fe77"
import script from "./basic-info.vue?vue&type=script&lang=js"
export * from "./basic-info.vue?vue&type=script&lang=js"
import style0 from "./basic-info.vue?vue&type=style&index=0&id=0b45fe77&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports